import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { WindowRefService } from '../services/helpers/window-ref.service';
import { RedirectRoutingKeyParams } from '../constants/route-params';

@Injectable()
export class RedirectGuard {
    private window: Window;

    constructor(private windowRefService: WindowRefService) {
        this.window = this.windowRefService.window;
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        let url = '';
        if (route.data[RedirectRoutingKeyParams.external]) {
            url = `${route.data[RedirectRoutingKeyParams.external]}`;
        } else if (route.data[RedirectRoutingKeyParams.ng1]) {
            url = `${this.window.location.origin}${route.data[RedirectRoutingKeyParams.ng1]}`;
        }

        if (url) {
            this.window.location.href = url;
            return true;
        } else {
            return false;
        }
    }
}
